import { deleteRequest, getRequest, postRequest, putRequest } from '../../request'

/**
 * 获取 地址
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function getCommonAreaList (params) {
  const url = 'api/v1/area'
  return getRequest(url, params)
}

/**
 * 获取订单详情
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function getOrderDetail (params) {
  const url = 'api/v1/pinTuanInfo'
  return getRequest(url, params)
}

/**
 * 订单确认
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function confirmOrder (params) {
  const url = 'api/v1/confirmOrder'
  return postRequest(url, params)
}

/**
 * 添加地址
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function addAddress (params) {
  let url = 'api/v1/user/address'
  return postRequest(url, params)
}

/**
 * 获取地址列表
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function getAddressList (params) {
  let url = 'api/v1/user/addresses'
  return getRequest(url, params)
}

/**
 * 将地址设置成默认
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function setDefaultAddress (params) {
  let url = 'api/v1/user/address/default'
  return putRequest(url, params)
}

/**
 * 删除地址
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function deleteAddress (params) {
  let url = 'api/v1/user/address'
  return deleteRequest(url, params)
}

/**
 * 编辑地址
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function updateAddress (params) {
  let url = 'api/v1/user/address'
  return putRequest(url, params)
}

/**
 * 微信支付
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function wxPay (params) {
  let url = 'api/v1/pay/start'
  return postRequest(url, params)
}

/**
 * 创建订单
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function createOrderGroupBuy (params) {
  let url = 'api/v1/pinTuan/createOrder'
  return postRequest(url, params)
}

/**
 * 微信授权登录
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function wechatAuthLogin (params) {
  let url = 'api/v1/user/login/h5'
  return postRequest(url, params)
}

/**
 * 微信授权登录 用作于 直播测试
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function wechatAuthLoginLiveTest (params) {
  let url = 'liveapi/api/v1/user/login/h5'
  return postRequest(url, params)
}

/**
 * 微信授权登录
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function getMessageCode (params) {
  let url = 'api/v1/message/sms'
  return getRequest(url, params)
}

/**
 * 微信授权登录
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function bindMobile (params) {
  let url = 'api/v1/user/setPhone'
  return putRequest(url, params)
}

/**
 * 改变地址时重新获取价格
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function orderChangeAddress (params) {
  let url = 'api/v1/orderChangeAddress'
  return postRequest(url, params)
}

/**
 * 获取微信分享数据
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function getGroupBuyShareData (params) {
  let url = 'api/v1/wxShare'
  return getRequest(url, params)
}

/**
 * 获取微信分享参数
 *
 * @param params
 *
 * @returns {Promise<any>}
 */
export function getWechatSignPackage (params) {
  let url = 'api/v1/getSignPackage'
  return postRequest(url, params)
}



// WEBPACK FOOTER //
// ./src/api/v1/groupBuy/index.js